
import DialogBase from "@/views/paper/paper-result-report/component/dialog-base.vue";

import { Component, Vue } from "vue-property-decorator";
@Component({ components: { DialogBase } })
export default class DialogOCEAN extends Vue {}
